var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineSingleArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.001 7.959 9 25.96"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m28.77 6.19-3.183 9.547-6.364-6.364z"
})));
export default SvgLineSingleArrowIcon;